module.exports = __webpack_public_path__ + "img/7-0-0.8609a82c.png";